import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// nodejs library to set properties for components
import PropTypes from "prop-types";
// @mui/material components

// core components
import useStyles from "./styles/cardBodyStyle.js";

export default function CardBody(props) {
  const classes = useStyles();
  const { className, children, plain, ...rest } = props;
  const cardBodyClasses = classNames({
    [classes.cardBody]: !plain,
    [classes.cardBodyPlain]: plain,
    [className]: className !== undefined
  });
  return (
    <div className={cardBodyClasses} {...rest}>
      {children}
    </div>
  );
}

CardBody.propTypes = {
  className: PropTypes.string,
  children: PropTypes.node,
  plain: PropTypes.bool
};
